import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Booking from './pages/Booking';
import Order from './pages/Order';
import { SnackbarProvider } from './providers/SnackbarProvider';

function App() {
    return (
        <BrowserRouter>
            <SnackbarProvider>
                <Routes>
                    <Route path="/" element={<Booking />} />
                    <Route path="/order/:link" element={<Order />} />
                </Routes>
            </SnackbarProvider>
        </BrowserRouter>
    );
}

export default App;
